import React from 'react'
import SALink from 'components/SALink'
import { Dimensions } from 'components/MeasurementUnit'
import { getCleanCategory } from 'components/Artworks/Info/helpers'

import classNames from 'classnames'

const Component = (
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<any>, any> => {
  const {
    shouldOpenNewDesktopPdpTab,
    artworkTitle,
    category,
    depth,
    handleViewProduct,
    hasPrints,
    height,
    isSeoValid,
    originalStatus,
    printUrl,
    productUrl,
    width,
  } = props
  // We need a singular category to display in hover
  const cleanCategory = getCleanCategory(category)
  return (
    <div
      data-style='column'
      sold={originalStatus === 'sold' ? true : null}
      data-type='artwork-info'
    >
      <div data-type='artwork-details'>
        <div data-type='main'>
          <SALink
            alt={`${artworkTitle}, ${category}`}
            href={hasPrints ? printUrl : productUrl}
            onClick={handleViewProduct}
            rel={isSeoValid ? null : 'nofollow'}
            title={`View ${artworkTitle} ${cleanCategory}`}
            target={shouldOpenNewDesktopPdpTab ? '_blank' : ''}
          >
            <h6 className={classNames('defaultTypographyH6', 'defaultTextTruncate')}>
              {artworkTitle}
            </h6>
          </SALink>
        </div>
        <div data-type='sub'>
          <p className={classNames('defaultTypographyXSmall')}>{category.replace(/-/g, ' ')}</p>
          {!hasPrints && (
            <>
              <p className={classNames('defaultTypographyXSmall')}>
                {`, `}
                <Dimensions dimensions={{ width, height, depth }} />
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Component
